export const StorageKey = {
	DAYS: 'days',
	DAY_TASKS: 'day-tasks',
	TASKS: 'tasks',
	TEMPLATES: 'templates',
} as const;
